export const FETCH_ANONYMOUS_MESSAGES_LIST = 'ANONYMOUS-MESSAGES/FETCH_ANONYMOUS_MESSAGES_LIST';
export const FETCH_ANONYMOUS_MESSAGES_LIST_ERROR = 'ANONYMOUS-MESSAGES/FETCH_ANONYMOUS_MESSAGES_LIST_ERROR';
export const CLEAR_ANONYMOUS_MESSAGES_LIST = 'ANONYMOUS-MESSAGES/CLEAR_ANONYMOUS_MESSAGES_LIST';

export const DELETE_ANONYMOUS_MESSAGE_SUCCESS = 'ANONYMOUS-MESSAGES/DELETE_ANONYMOUS_MESSAGE_SUCCESS';
export const DELETE_ANONYMOUS_MESSAGE_ERROR = 'ANONYMOUS-MESSAGES/DELETE_ANONYMOUS_MESSAGE_ERROR';
export const CLEAR_DELETE_ANONYMOUS_MESSAGE_STATUS = 'ANONYMOUS-MESSAGES/CLEAR_DELETE_ANONYMOUS_MESSAGE_STATUS';

export const PATCH_MESSAGE_SETTINGS_SUCCESS = 'ANONYMOUS-MESSAGES/PATCH_MESSAGE_SETTINGS_SUCCESS';
export const PATCH_MESSAGE_SETTINGS_ERROR = 'ANONYMOUS-MESSAGES/PATCH_MESSAGE_SETTINGS_ERROR';
export const CLEAR_PATCH_MESSAGE_SETTINGS_STATUS = 'ANONYMOUS-MESSAGES/CLEAR_PATCH_MESSAGE_SETTINGS_STATUS';

export const FETCH_ANONYMOUS_MESSAGES_CSV = 'ANONYMOUS-MESSAGES/FETCH_ANONYMOUS_MESSAGES_CSV';
export const FETCH_ANONYMOUS_MESSAGES_CSV_ERROR = 'ANONYMOUS-MESSAGES/FETCH_ANONYMOUS_MESSAGES_CSV_ERROR';
export const CLEAR_FETCH_ANONYMOUS_MESSAGES_CSV = 'ANONYMOUS-MESSAGES/CLEAR_FETCH_ANONYMOUS_MESSAGES_CSV';
